import { usePostOnboardingAuth } from "@/hooks/usePostOnboardingAuth"
import { useAuthStore } from "@/stores/useAuthStore"
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router"
import { useEffect } from "react"
import { LoginWrapper } from "toptaal-shared"

export const Route = createFileRoute("/auth/sso_callback/")({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      token: String(search.token),
      refreshToken: String(search.refresh_token),
    }
  },
})

function RouteComponent() {
  const router = useRouter()

  const setToken = useAuthStore((state) => state.setToken)
  const setRefreshToken = useAuthStore((state) => state.setRefreshToken)

  const { token, refreshToken } = useSearch({
    from: "/auth/sso_callback/",
  })

  useEffect(() => {
    if (!token || !refreshToken) {
      router.navigate({ to: "/auth/failed_sso", replace: true })

      return
    }

    setToken(token)
    setRefreshToken(refreshToken)
  }, [token, refreshToken, setToken, setRefreshToken, router])

  usePostOnboardingAuth()

  return (
    <LoginWrapper title="Laden">
      <div>Laden...</div>
    </LoginWrapper>
  )
}
